import { render, staticRenderFns } from "./ViewCompanyStats.vue?vue&type=template&id=4d7fd745&scoped=true&"
import script from "./ViewCompanyStats.vue?vue&type=script&lang=js&"
export * from "./ViewCompanyStats.vue?vue&type=script&lang=js&"
import style0 from "./ViewCompanyStats.vue?vue&type=style&index=0&id=4d7fd745&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d7fd745",
  null
  
)

export default component.exports